// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__3BYeA","title":"ClientInsurance_title__1iiZz","itemText":"ClientInsurance_itemText__2XQ-L"};